// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11lCY","left":"styles_left__1g7sl","desktopActions":"styles_desktopActions__P-czk","title":"styles_title__NIfOt"};